import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import { useSessionStore } from '@/stores/useSessionStore'
import { resolveInstrumentMetadata } from '@/features/instruments/infra/instrument.api'

function tenantKey(tenantId: string | null | undefined) {
  return tenantId ?? '_'
}

export function useInstrument(
  instrumentId: string,
  options?: { enabled?: boolean },
) {
  const tenantId = useSessionStore((s) => s.user?.tenantId)
  const isAuthenticated = useSessionStore((s) => s.isAuthenticated)
  const enabled =
    (options?.enabled ?? true) &&
    isAuthenticated &&
    instrumentId.length > 0

  return useQuery({
    queryKey: queryKeys.instruments.detail(tenantKey(tenantId), instrumentId),
    queryFn: ({ signal }) => resolveInstrumentMetadata({ instrumentId, signal }),
    enabled,
  })
}
